/*
 * @Author: Latte
 * @Date: 2021-09-07 16:27:48
 * @LAstEditors: Latte
 * @LastEditTime: 2021-09-23 09:34:25
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\mai\liveReviews\liveReviews.js
 */

///都是前端接口，要改成后端接口


import request from '@/utils/request'
import config from '@/utils/config'
import {
    getForumCategoryList
} from "@/api/ultrasonic"
import {handleUrlEncode} from "@/utils/urlutil";

/**
 * 往期回顾接口
 */

/**
 * @description: 添加往期回顾视频信息
 * @param {*} data
 * @return {*}
 */
export function addInfo(data) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveReview/Add',
        method: 'post',
        data
    })
}

/**
 * @description: 删除单个往期回顾视频
 * @param {*} params
 * @return {*}
 */
export function deleteVideo(params) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveReview/DeleteOrBack',
        method: 'delete',
        params
    })
}

/**
 * @description: 恢复单个往期回顾视频
 * @param {*} params
 * @return {*}
 */
export function resumeVideo(params) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveVideos/DeleteOrBack',
        method: 'delete',
        params
    })
}

/**
 * @description: 根据tabID分页获取所有往期回顾的视频
 * @param {*} params
 * @return {*}
 */
export function getVideoListByTag(params) {
    var url = config.API_ADMIN + '/Api/V1/AdminLiveReview/LiveReview/List?'
    url = handleUrlEncode(url,params)
    return request({
        url: url,
        method: 'get'
    })
}

/**
 * @description: 保存往期回顾评论文件
 * @param {*} data
 * @return {*}
 */
export function saveCommentFile(data) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveReview/LiveCommentFile/Add',
        method: 'post',
        data
    })
}

/**
 * @description: 分页获取往期回顾评论集合
 * @param {*} params
 * @return {*}
 */
export function getCommentList(params) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveReview/LiveComment/List',
        method: 'get',
        params
    })
}

/**
 * @description: 后台直播回顾视频评论删除或者恢复
 * @param {*} data
 * @return {*}
 */
export function liveCommentDeleteOrBack(data) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveReview/LiveComment/DeleteOrBack',
        method: 'delete',
        params:data
    })
}

/**
 * @description: 后台管理获取指定往期视频对应赚取的麦粒总值和记录
 * @param {*} params
 * @return {*}
 */
export function getLiveReviewCreditOrderList(params) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveReview/LiveReview/CreditOrder/List',
        method: 'get',
        params
    })
}

/**
 * @description: 后台添加往期回顾视频标签
 * @param {*} data
 * @return {*}
 */
export function addTag(data) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveReview/LiveVideoTab/Add',
        method: 'post',
        data
    })
}

/**
 * @description: 后台删除往期回顾视频标签
 * @param {*} params
 * @return {*}
 */
export function deleteTag(params) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveReview/LiveVideoTab/Delete',
        method: 'delete',
        params
    })
}

/**
 * @description: 后台设置往期视频标签是否为系统默认标签
 * @param {*} data
 * @return {*}
 */
export function setDefaultTag(data) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveVideos/LiveVideoTab/SystemDefault',
        method: 'post',
        data
    })
}

/**
 * @description: 后台更新往期回顾视频标签
 * @param {*} data
 * @return {*}
 */
export function updateTag(data) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveReview/LiveVideoTab/Update',
        method: 'post',
        data
    })
}

/**
 * @description: 获取往期回顾直播视频的所有标签
 * @param {*} params
 * @return {*}
 */
export function getTagList(params) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveReview/LiveVideoTab/List',
        method: 'get',
        params
    })
}

/**
 * fixme
 * 获取往期回顾所有类型
 */
export function getCategoryList() {
    return getForumCategoryList()
}

/**
 * @description: 后台获取指定往期回顾视频详情
 * @param {*} params
 * @return {*}
 */
export function getVideoDetail(params) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveReview/One',
        method: 'get',
        params
    })
}

/**
 * @description: 后台分页获取指定往期回顾视频评论回复集合
 * @param {*} params
 * @return {*}
 */
export function getReplyLiveCommentList(params) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveReview/LiveComment/Reply/List',
        method: 'get',
        params
    })
}

/**
 * @description: 后台更新指定往期回顾视频信息
 * @param {*} data
 * @return {*}
 */
export function updateVideoInfo(data) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveReview/Update',
        method: 'post',
        data
    })
}

/**
 * @description: 后台分页获取指定往期回顾视频对应的用户观看信息情况集合
 * @param {*} data
 * @return {*}
 */
export function getWatchUserList(data) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminLiveReview/WatchUser/List',
        method: 'get',
        params: data
    })
}

